import React, { useState } from 'react';
import { Space, Input, Select, Table } from 'tt-ui-lib/core';
import { SearchIcon } from 'tt-ui-lib/icons';

const MailingListTab = ({ selectedChildTab }) => {
  const columns = [
    { key: 'creationDate', dataIndex: 'creationDate', title: 'Creation date' },
    { key: 'mailingDate', dataIndex: 'mailingDate', title: 'Mailing date' },
    { key: 'subject', dataIndex: 'subject', title: 'Subject' },
    { key: 'emailList', dataIndex: 'emailList', title: 'Email list' },
    { key: 'actions', dataIndex: 'actions', title: '', width: '50px' },
  ];

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <b>Total found: {data.length}</b>228
      </Space>

      <Space>
        <Input
          placeholder="Search"
          prefix={<SearchIcon style={{ width: '20px', height: '20px' }} />}
          style={{ width: '100%', maxWidth: '300px' }}
        />
        <Select options={[]} placeholder="Sort by" style={{ width: '100%', maxWidth: '200px' }} />
      </Space>

      <Table data={data} columns={columns} loading={isLoading} />
    </>
  );
};

export default MailingListTab;
